import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

export const useLanguage = () => {
  const language = useSelector((state: RootState) => state.params.lng);
  return language;
};
